import React from 'react';

export default function Navigation({ links, active, onSelect }) {
  return (
    <nav className="hidden lg:flex items-center gap-7">
      {links.map((l) => (
        <a
          key={l.href}
          href={l.href}
          onClick={() => onSelect(l.label)}
          className={`nav-link text-[15px] ${active === l.label ? 'active' : ''}`}
        >
          {l.label}
        </a>
      ))}
    </nav>
  );
}
